// PIN oynasi ostidagi "Ilovani o'rnatish": brauzer ruxsat bersa — bir bosishda; iPhone'da — yo'riqnoma.
import { useState } from 'react';
import { Icon } from '@onepos/ui';
import { useInstall } from '../lib/install';

export function InstallApp() {
  const { mode, install } = useInstall();
  const [hint, setHint] = useState(false);
  if (!mode) return null;
  return (
    <div className="ks-install">
      <button type="button" className="ks-install__btn" onClick={() => (mode === 'prompt' ? void install() : setHint((v) => !v))} aria-expanded={mode === 'ios' ? hint : undefined}>
        <Icon name="download" /> Ilovani o‘rnatish
      </button>
      {hint && (
        <p className="ks-install__hint">
          Safari’da pastdagi <b>Ulashish</b> tugmasini bosing, so‘ng <b>“Bosh ekranga”</b> (Add to Home Screen) ni tanlang. Ilova ekranda alohida belgi bo‘lib turadi.
        </p>
      )}
    </div>
  );
}
